module.exports = __webpack_public_path__ + "static/media/shutterstock_2029347044.43c83649.png";